import 'projects/sharedComponents/src/healthSummaryCard/healthSummaryCardItem.scss';

import { Card, CardActionArea, Grid, Stack, Typography } from '@mui/material';
import { UrlPathPrefix, buildMyEvLegacyLink } from 'projects/sharedComponents/src/services/links/linkBuilder';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { HealthSeverity } from 'projects/sharedComponents/src/generated/graphql-client-types';
import { RenderIf } from 'projects/sharedComponents/src/renderStates/renderIf';

type HealthSummaryCardItemProps = {
  title: string;
  subText?: string;
  logoUrl: string;
  ctaLink: string;
  severity?: HealthSeverity;
};

export const HealthSummaryCardItem: React.FC<HealthSummaryCardItemProps> = ({
  title,
  logoUrl,
  subText,
  ctaLink,
  severity,
}) => {
  const cardTitle = !!severity ? `${severity}, ${title}` : title;
  return (
    <Card className="healthSummaryCardItem-card">
      <CardActionArea href={buildMyEvLegacyLink(ctaLink as UrlPathPrefix)} title={cardTitle}>
        <Grid container alignItems="center" marginBottom="6px">
          <Grid item xs={9} sm={10}>
            <Grid container alignItems="baseline">
              <Grid item xs={12} sm={!!subText ? 6 : 12}>
                <Typography className="healthSummaryCardItem-title">
                  <strong>{title}</strong>
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <RenderIf condition={!!subText}>
                  <Typography className="healthSummaryCardItem-subText">
                    <strong>{subText}</strong>
                  </Typography>
                </RenderIf>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={3} sm={2} className="healthSummaryCardItem-icons">
            <Stack direction="row" justifyContent="flex-end" alignItems="center" spacing={1}>
              <img src={logoUrl} alt={severity} height={20} className="healthSummaryCardItem-logo" />
              <ChevronRightIcon className="healthSummaryCardItem-arrowIcon" height={15} />
            </Stack>
          </Grid>
        </Grid>
      </CardActionArea>
    </Card>
  );
};
